<template>
  <div>
    <h3>Envío de códigos promocionales</h3>
    <p>El equipo de {{host}} le agradece su confianza. En señal de agradecimiento, enviaremos periódicamente códigos promocionales a los jugadores habituales. ¡Disfruta el juego!</p>
  </div>
</template>
<script>
  export default {
    name: 'bonus-rules-mailing-es',
    computed: {
      host() {
        return window.location.hostname;
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/es.vue